import Model from '../../util/model';

export default class CountryModel extends Model {}
